import ApiService from '@/services/api'
import { defineStore } from 'pinia'
//import { taskUpdateService } from '@/rxjsServices';

const ENDPOINT = '/livestocks/'
const ITEM_ID  = 'lst_id'

export const useLivestockStore = defineStore('livestocks', {
  //storage option
  persist: true,
  // convert to a function
  state: () => ({
    item: { lst_id:null, lst_customfields: {} },
    itemList: [],
    correctedTag: [],
  }),
  getters: {

  },
  actions: {
    fetchItem (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id > 0 ){
                ApiService.get(ENDPOINT + id + options).then( (response) => {
                    if( !response.data.data.lst_customfields || Object.prototype.toString.call( response.data.data.lst_customfields ) === '[object Array]' ) {
                        response.data.data.lst_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => { 
                    if (error.response && (error.response.status === 404 || error.response.status === 400)) {
                        resolve(this.item)  // ← Résout au lieu de reject
                    } else {
                        reject(error)
                    }
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItemByTag (id, options) {
        return new Promise( (resolve, reject) => {
            options = (options) ? '/' + options : ''
            if( id && id.length > 0 ){
                ApiService.get(ENDPOINT + 'tag/' + id + options).then( (response) => {
                    if( !response.data.data.lst_customfields || Object.prototype.toString.call( response.data.data.lst_customfields ) === '[object Array]' ) {
                        response.data.data.lst_customfields = {}
                    }
                    this.SET_ITEM(response.data.data)
                    resolve(this.item)
                }).catch( (error) => {
                    if (error.response && (error.response.status === 404 || error.response.status === 400)) {
                        resolve(this.item)  // ← Résout au lieu de reject
                    } else {
                        reject(error)
                    }
                })
            } else {
                this.RESET_ITEM()
                resolve(this.item)
            }
        })
    },
    fetchItems (options) {
        options = (options) ? options : ''
        return new Promise( (resolve, reject) => {
            ApiService.get( ENDPOINT + options ).then( (response) => {
                this.metaTask = response.data.meta
                if( Object.prototype.toString.call( response.data.data ) === '[object Array]' ) {
                    this.SET_ITEMS(response.data.data)
                }
                resolve('resolved')
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    storeItem () {
        return new Promise( (resolve, reject) => {
            ApiService.post( ENDPOINT, this.item ).then( (response) => {
                this.SET_ITEM(response.data.data)
                resolve(this.item)
            }).catch( (error) => { 
                reject(error)
            })
        })
    },
    updateItem (item) {
        return new Promise( (resolve, reject) => {
            if(item){
                this.SET_ITEM(item)
            }
            ApiService.put( ENDPOINT + this.item[ITEM_ID], this.item ).then( (response) => {
            this.SET_ITEM(response.data)
            resolve(this.item)
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    destroyItem (id) {
        return new Promise( (resolve, reject) => {
            this.item[ITEM_ID] = (id) ? id : this.item[ITEM_ID]
            ApiService.delete(ENDPOINT + this.item[ITEM_ID]).then( () => {
                this.RESET_ITEM()
            resolve('resolved')
            }).catch( (error) => { 
            reject(error)
            })
        })
    },
    formatTag(texte) {
        return new Promise( (resolve) => {
            if (typeof texte !== "string"){
                this.correctedTag = [];
                resolve('')
                return;
            }

            const mapping = {
                'Q': 'A', 'q': 'A',
                'à': '0', 'À': '0',
                "'": '4', '’': '4',  // apostrophe droite et typographique
                'é': '2', 'É': '2',
                '(': '5',
                '"': '3',
                '-': '6',
                '_': '8',
                '&': '1',
                'ç': '9', 'Ç': '9',
                'è': '7', 'È': '7',
                '°': '', // caractère parasite fréquent
                ':': '',
                // AJOUTS POUR LES SYMBOLES SUPPLÉMENTAIRES DU SCANNER
                '§': '6',  // La touche § sur AZERTY est le 8 en QWERTY
                '!': '8',  // Souvent confondu selon la config majuscule
                '^': '9',
            };

            const lignes = texte.split(/\r?\n/);
            const resultats = [];
            for (let ligne of lignes) {
                let trim = ligne.trim();
                if (!trim || trim.length < 8) continue;

                let transforme = '';
                for (let char of trim) {
                    transforme += mapping[char] !== undefined ? mapping[char] : char;
                }

                // On garde uniquement les numéros qui commencent par A00 et qui sont assez longs
                if ( (transforme.startsWith("A00") || transforme.startsWith("250")) && transforme.length >= 15) {
                    transforme = transforme.trim().replace(/\s+/g, ''); // Supprime tous les espaces //
                    resultats.push(transforme);
                }
            }
            this.correctedTag = resultats; //JSON.stringify(resultats, null, 2);
            if( resultats.length > 1 ){
                resolve(resultats);
            } else {
                resolve(resultats[0]);  // ← 2. Ajouter resolve()
            }
            
        })
    },
    //***************************MUTATIONS ***************************************/
    SET_ITEM (item) {
      this.item = item
    },
    SET_ITEMS (itemList) {
      this.itemList = itemList
    },
    RESET_ITEM () {
        this.item = { 
            lst_id:null,
            lst_tag: '',
            lst_sta_id: 'LST01',
            lst_typ_id: 'LST01',
            lst_typ_id_spec: 'LTT01',
            lst_breed: '',
            lst_sex: 'M',
            lst_birth_date: null,
            lst_acquisition: null,
            lst_name: '',
            lst_description: '',
            lst_tag_father: '',
            lst_tag_mother: '',
            lst_customfields : {} 
        }
        this.correctedTag= []
    }
  }
})
